import {
  CreatePromoCodeRequest,
  PromoCode,
  PromoCodeUsage,
} from '../types/promoCodes';
import { handleResponse } from './handleResponse';
import apiAxios from './apiAxios';
import { DateRange } from '../utility/dates';

const promoCodesApi = {
  async listCompanyPromoCodes(
    companyId: string,
    filters?: { dateRange?: DateRange }
  ): Promise<PromoCode[]> {
    return apiAxios
      .get(`/api/companies/${companyId}/codes`, {
        params: {
          startDate: filters?.dateRange
            ? filters.dateRange.from.getTime() / 1000
            : undefined,
          endDate: filters?.dateRange
            ? filters.dateRange.to.getTime() / 1000
            : undefined,
        },
      })
      .then(handleResponse);
  },
  async companyPromoCodeDetails(
    companyId: string,
    codeId: string
  ): Promise<PromoCode> {
    return apiAxios
      .get(`/api/companies/${companyId}/codes/${codeId}`)
      .then(handleResponse);
  },
  async createCompanyPromoCode(
    companyId: string,
    params: CreatePromoCodeRequest
  ): Promise<PromoCode> {
    return apiAxios
      .post(`/api/companies/${companyId}/codes`, params)
      .then(handleResponse);
  },
  async deleteCompanyPromoCode(
    companyId: string,
    codeId: string
  ): Promise<void> {
    return apiAxios
      .delete(`/api/companies/${companyId}/codes/${codeId}`)
      .then(handleResponse);
  },
  async searchCompanyPromoCodes(companyId: string, query: string) {
    return apiAxios
      .get<Promise<PromoCode[]>>(`/api/companies/${companyId}/codes/search`, {
        params: { q: query },
      })
      .then(handleResponse);
  },
  async addPromoCodeUsage(
    companyId: string,
    clientId: string,
    codeId: string,
    params: {
      date: string;
    }
  ): Promise<PromoCodeUsage> {
    return apiAxios
      .post(
        `/api/portal/company/${companyId}/clients/${clientId}/codes/${codeId}/usage`,
        params
      )
      .then(handleResponse);
  },
  async deletePromoCodeUsage({
    companyId,
    codeId,
    usageId,
  }: {
    companyId: string;
    codeId: string;
    usageId: string;
  }): Promise<void> {
    return apiAxios
      .delete(`/api/companies/${companyId}/codes/${codeId}/usage/${usageId}`)
      .then(handleResponse);
  },
  async addGiftCardCodeUsage(
    companyId: string,
    codeId: string,
    body: { date: string; amount: number; comment: string }
  ): Promise<{
    id: string;
    receivedAt: string;
    requestedAt: string;
    reservationId?: string;
    userId: string;
  }> {
    return apiAxios
      .post(`/api/companies/${companyId}/codes/${codeId}/usage`, body)
      .then(handleResponse);
  },
};

export default promoCodesApi;
